import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/index'
import VueI18n from 'vue-i18n'
import messages from '@/i18n/index'
Vue.config.productionTip = false

import Cookies from 'js-cookie'
const i18n = new VueI18n({
  locale: localStorage.getItem('lang')||"en",
  messages,
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
